// src/pages/RestaurantPOS/manager/AfricanManagerDashboard.jsx
import React from 'react';
import ManagerDashboard from './ManagerDashboard';

const AfricanManagerDashboard = () => {
  return <ManagerDashboard locationKey="african" />;
};

export default AfricanManagerDashboard;